export const LANGUAGES = [
    { code: 'en', name: 'English' },
    { code: 'da', name: 'Danish' },
    { code: 'fi', name: 'Finnish' },
    { code: 'is', name: 'Icelandic' },
    { code: 'no', name: 'Norwegian' },
    { code: 'sv', name: 'Swedish' },
    { code: 'es', name: 'Spanish' },
    { code: 'pt', name: 'Portuguese' },
];

export const LANGUAGE_CODES = LANGUAGES.map(({ code }) => code);

export const LANGUAGE_NAMES = LANGUAGES.reduce((acc, language) => {
    acc[language.code] = language.name;
    return acc;
}, {});

export const createEmptyTranslations = () =>
    LANGUAGE_CODES.reduce((acc, code) => {
        acc[code] = '';
        return acc;
    }, {});
